import CreatePassword from './CreatePasswordContainer';

export default CreatePassword;